import React, { Component}  from 'react';
import loadable from '@loadable/component';
import DefaultLoading from '../../elements/defaultLoading/defaultLoading';

export default loadable((props) => import('./workfiles'), {
    fallback: <DefaultLoading />,
});